import { createFileRoute } from "@tanstack/react-router";

import { AdminStylesScreen } from "@/features/admin/screens/AdminStyles";

export const Route = createFileRoute("/_authenticated/(admin)/admin/styles")({
  component: AdminStylesScreen,
});
